import { useEffect } from "react";
import MaterialTable from "material-table";
import {
    Box,
    Button,
    Select,
    Typography,
    MenuItem,
    Grid,
    CircularProgress,
    IconButton,
    FormControl,
    Tooltip,
    Menu,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from '@mui/icons-material/Delete';
import { useSelector } from "react-redux";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getUserData, getUserId } from "../../../Base/helper/baseFunctions";
import Popup from "../../../Base/views/Popup";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { GetOTAction, GetPayrollTemplateAction } from "../../../../../store/Finance/PayRollTemplate/Action";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import {  BulkUploadCalculateAdvanceHelper, BulkUploadCalculateHelper, BulkUploadCalculateMonthlyCtcHelper, BulkUploadCUContractualDailyHelper, BulkUploadCUContractualHelper, BulkUploadCUContractualPayableDaysHelper, DeletePayrollStageHelper, GetPayrollStageHelper, UpdatePayrollStageHelper } from "../../helper/BulkUpload/BulkUploadHelper";
import CloseIcon from '@mui/icons-material/Close';
import { GetCustomDeductionAction, GetCustomEarningAction } from "../../../../../store/Finance/Component/Action";
import { BulkPayrollLoadAction } from "../../../../../store/Finance/BulkUpload/Action";
import PreviewIcon from '@mui/icons-material/Preview';
import PayrollBulkPreview from "../../helper/BulkUpload/PayrollBulkPreview";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

const PayrollBulkUpload = () => {
    const dispatch = useDispatch();
    let userData = getUserData();
    const [, setOpenBulk] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [editedRecord, setEditedRecord] = useState(null);
    const [id, setId] = useState();
    const [resWarData, setResWarData] = useState({
        warning: "",
        stage_payroll_pk: "",
        isOpen: false
    });
    const [openPopup, setOpenPopup] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentData, setCurrentData] = useState({});
    // const [editerrors, setEditErrors] = useState({});
    const [empdata, setEmpData] = useState([]);
    const [stageData, setStageData] = useState([]);
    const [errors, setErrors] = useState({});
    const [file, setFile] = useState(null);
    const [selecttemp, setSelectTemp] = useState("Meepl Salary Template");
    const earningTempSelected = 
            selecttemp === "Advanced Meepl Salary Template : Annual" || 
            selecttemp === "Contractual Template" || 
            selecttemp === "Contractual Template : Daily Fixed" ||
            selecttemp === "Contractual Template : Payable Days" ||
            selecttemp === "Advanced Meepl Salary Template : Monthly";  // template with Earning and Deduction Variables
    const templateEarningsValues = {
        earning_key: "",
        earning_value: "0",
    };
    const templateDeductionsValues = {
        deduction_key: "",
        deduction_value: "0",
    };
    const [earningData, setEarningData] = useState({
        load: true,
        values: [],
    });
    const [deductionData, setDeductionData] = useState({
        load: true,
        values: [],
    });
    const [templateEarningData, setTemplateEarningData] = useState([]);
    const [templateDeductionData, setTemplateDeductionData] = useState([]);
    const isLoading = useSelector((state) => state.BulkUploadReducer.isLoading);
    const { payroll_template_data } = useSelector(
        (state) => state?.FinanceReducer.PayrollTemplateReducer
    );
    const { custom_earning_data, custom_deduction_data } = useSelector(
        (state) => state?.FinanceReducer.ComponentReducer
    );
    const selectedTemplateName = payroll_template_data?.find(t => t.template_name === "Meepl Salary Template");
    const initialColMapping = [ // don't change the indexing of existing fields, add new fields in the end with appropriate indexing in useEffect
        { excel: "", db: "previous_employee_id", label: "Prev.Emp ID", required: true },
        { excel: "", db: "ctc", label: "CTC (Annually)", required: true },
        { excel: "", db: "basic", label: "Basic %", required: true },
        { excel: "", db: "hra", label: "HRA %", required: true },
        { excel: "", db: "conveyance_allowance", label: "Conveyance Allowance", required: false },
        { excel: "", db: "medical_allowance", label: "Medical Allowance", required: false },
        { excel: "", db: "educational_allowance", label: "Educational Allowance", required: false },
        { excel: "", db: "lta", label: "LTA", required: false },
        { excel: "", db: "esic_reg_no", label: "ESI Number", required: false }, // 8
        { excel: "", db: "esic", label: "ESIC Applicable", required: false },
        { excel: "", db: "pt", label: "PT Applicable", required: false },
        { excel: "", db: "statutory_bonus_flag", label: "Statutory Bonus", required: false },
        { excel: "", db: "gratuity_flag", label: "Gratuity", required: false },
        { excel: "", db: "pf_compliant_flag", label: "PF Compliant Tag", required: false },
        { excel: "", db: "pf_reg_no", label: "EPF Number", required: false },
        { excel: "", db: "pf", label: "PF Applicable", required: false },
        { excel: "", db: "eps_applicable_flag", label: "EPS Applicable", required: false },
        { excel: "", db: "pf_limit_amount", label: "PF Limit Amount", required: false },
        { excel: "", db: "overtime_code", label: "Overtime", required: false },
        { excel: "", db: "transport_allowance_applicable", label: "Transport Allowance Applicable", required: false },
        { excel: "", db: "food_allowance_applicable", label: "Food Allowance Applicable", required: false },
        { excel: "", db: "week_off_caln_applicable", label: "Include Paid Week Offs", required: false },
        { excel: "", db: "working_hrs_monthly_caln", label: "Monthly Working Hours Calculation", required: false },
        { excel: "", db: "onhold_payroll_flag", label: "Hold Salary", required: false },
    ];
    const [excelDbColMapping, setExcelDbColMapping] = useState(initialColMapping);
    const [, setIsAdvancedTemplate] = useState(false);
    const [contractual, setContractual] = useState(false);
    const [contractualDaily, setContractualDaily] = useState(false);
    const [, setContractualPayableDays] = useState(false);
    const [monthlyCtcTemplate, setMonthlyCtcTemplate] = useState(false); // monthly_ctc_autocalculator_template_applied
    const [excelDbCol, setExcelDbCol] = useState([]);
    const [excelDbCol1, setExcelDbCol1] = useState([]);
    const [rowHeaders, setRowHeaders] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [templateData, setTemplateData] = useState({ load: true, values: [] });
    const [inputData, setInputData] = useState({ template_id: "" });
    const [selectFileBtnLoading, setSelectFileBtnLoading] = useState(false);

    const { ot_data } = useSelector(state => state.FinanceReducer?.PayrollTemplateReducer);
    
    useEffect(() => {
        dispatch(GetPayrollTemplateAction());
        dispatch(GetCustomEarningAction());
        dispatch(GetCustomDeductionAction());
        dispatch(GetOTAction())
        setInputData({
            ...inputData,
            template_id: { template_id: selectedTemplateName?.template_id, template_name: "Meepl Salary Template" },
        });
        setSelectFileBtnLoading(true);
        GetPayrollStageHelper().then((res) => {
            setEmpData(res?.data?.data?.[0]?.payroll_details);
            setStageData(res?.data?.data);
            setId(res?.data?.data?.[0]?.stage_payroll_pk);
            setSelectFileBtnLoading(false);

            if (res?.data?.data?.[0]?.template_name) {
                const tempName = res?.data?.data?.[0]?.template_name
                setSelectTemp(res?.data?.data?.[0]?.template_name);
                setIsAdvancedTemplate(tempName === "Advanced Meepl Salary Template : Annual");
                setContractual(tempName === "Contractual Template")
                setContractualDaily(tempName === "Contractual Template : Daily Fixed");
                setContractualPayableDays( tempName === "Contractual Template : Payable Days");
                setMonthlyCtcTemplate(tempName === "Advanced Meepl Salary Template : Monthly");
            }
            else {
                setSelectTemp("Meepl Salary Template");
                setIsAdvancedTemplate(false);
                setContractual(false);
                setContractualDaily(false);
                setContractualPayableDays(false);
                setMonthlyCtcTemplate(false);
            }
        });
          // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleReset = () => {
        setTemplateEarningData([]);
        setTemplateDeductionData([]);
        setExcelDbCol([]);
        setExcelDbCol1([]);
    } 
    const handleTemplate = () => {
        payroll_template_data &&
            setTemplateData({ load: false, values: payroll_template_data?.filter((el) => el?.is_default && el?.template_name !== "Work-Based Pay") });
    };
    const handleInput = (event, value) => {
        const selectedTemplate = payroll_template_data?.find(t => t.template_name === value?.template_name);
        setSelectTemp(selectedTemplate.template_name);
        setIsAdvancedTemplate(selectedTemplate?.template_name === "Advanced Meepl Salary Template : Annual");
        setContractual(selectedTemplate?.template_name === "Contractual Template")
        setContractualDaily(selectedTemplate?.template_name === "Contractual Template : Daily Fixed");
        setContractualPayableDays(selectedTemplate?.template_name === "Contractual Template : Payable Days");
        setMonthlyCtcTemplate(selectedTemplate?.template_name === "Advanced Meepl Salary Template : Monthly");
        
        if (selectedTemplate) {
            // if else condition for changing the dbExcelColormn moved to useEffect
            handleReset();
        } else {
            setExcelDbColMapping([]);
            handleReset();
        }

        if (event === "template_id") {
            setInputData({ ...inputData, [event]: value });
        }
    };
    const handleSelectFileClick = () => {
        setInputData({
            ...inputData,
            template_id: { template_id: selectedTemplateName?.template_id, template_name: "Meepl Salary Template" },
        });
        setSelectTemp("Meepl Salary Template")
        if (empdata?.length > 0) {
            setShowConfirmPopup(true); // Show confirmation popup if data exists
        } else {
            if(stageData?.length > 0){
                handleCancel();
            }
            document.getElementById("contained-button-file").click();

            // Directly trigger file selection if no data exists
        }
    };
    const fileSelected = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
        processFile(selectedFile, e);
    };
    const processFile = (selectedFile, event) => {
        setFile(selectedFile);
        setExcelDbColMapping(initialColMapping);
        setTemplateEarningData([]);
        setTemplateDeductionData([]);
        setUploadProgress(0);
        const fileReader = new FileReader();
        toast.dismiss();
        toast.info("Reading File. Please wait");
        fileReader.onload = (e) => {
            const arrayBuffer = e.target.result;
            const workbook = XLSX.read(arrayBuffer, { type: "array" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const firstRowData = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                range: 0,
            });
            setRowHeaders(firstRowData[0]);
            toast.dismiss();
            toast.success("File imported");
        };

        fileReader.readAsArrayBuffer(selectedFile);
        if (event) event.target.value = ""; // Reset the input
    };
    function setColMapping(value, dbCol) {
        setExcelDbColMapping((prev) => {
            prev.forEach((col) => {
                if (col["db"] === dbCol) col.excel = value;
            });
            return [...prev];
        });
        setExcelDbCol((prev) => {
            prev.forEach((col) => {
                if (col["db"] === dbCol) col.excel = value;
            });
            return [...prev];
        });
        setExcelDbCol1((prev) => {
            prev.forEach((col) => {
                if (col["db"] === dbCol) col.excel = value;
            });
            return [...prev];
        });

    }
    function clearColMapping(dbCol) {
        setExcelDbColMapping((prev) => {
            prev.forEach((col) => {
                if (col["db"] === dbCol) col.excel = "";
            });
            return [...prev];
        });
    }
    const validate = () => {
        const temp = {};
        if (!file) temp.file = "File is required";
        const unmappedRequiredFields = excelDbColMapping?.filter(
            (col) => col.required && !col.excel
        );
        if (unmappedRequiredFields?.length > 0) {
            toast.dismiss();
            toast.error("Please map all required fields.")
            temp.columnMapping = "Please map all required fields.";
        }
        setErrors(temp);
        return Object.keys(temp)?.length === 0; // Return true if no errors
    };
    async function addPayrollStage(e) {
        if (!validate()) return;
        e.preventDefault();
        try {
            const formData = new FormData();
            const EarningformattedData = templateEarningData?.map((item) => ({
                name: item.earning_key?.name,
                label: item.earning_key?.label,
                value: item.earning_value,
            }));
            const DeductionformattedData = templateDeductionData?.map((item) => ({
                name: item.deduction_key?.name,
                label: item.deduction_key?.label,
                value: item.deduction_value,
            }));
            const formattedDataToSend = EarningformattedData?.length ? JSON.stringify(EarningformattedData) : null;
            const formattedDataDeductToSend = DeductionformattedData?.length ? JSON.stringify(DeductionformattedData) : null;
            const fullMapping = [
                ...excelDbColMapping?.map(col => ({
                    ...col,
                })),
                {
                    excel: JSON.stringify(excelDbCol?.map(el => el?.excel)) || "",
                    db: "earning_component_json",
                    required: false,
                    earning_component_json: formattedDataToSend
                },
                {
                    excel: JSON.stringify(excelDbCol1?.map(el => el?.excel)) || "",
                    db: "deduction_component_json",
                    required: false,
                    deduction_component_json: formattedDataDeductToSend
                }
            ];
            formData.append("file", file);
            formData.append("user_id", getUserId());
            formData.append("template_id", inputData?.template_id?.template_id);
            formData.append("template_name", inputData?.template_id?.template_name);
            formData.append("domain_name", userData?.domain);
            formData.append("column_mapping", JSON.stringify(earningTempSelected ? fullMapping : excelDbColMapping));
            toast.dismiss();
            toast.info("Uploading file");
            try {
                setUploadProgress(0);
                await axiosInstance
                    .post("/finance/uploadPayrollFile", formData, {
                        baseURL: HRMS_FINANCE_API_URL,
                        headers: {
                            Accept: "multipart/form-data",
                            "Content-Type": "multipart/form-data",
                        },
                        onUploadProgress: (progress) => {
                            const percentCompleted = Math.round((progress.loaded * 90) / progress.total);
                            setUploadProgress(percentCompleted);
                            if (percentCompleted > 89) {
                                toast.dismiss();
                                toast.info("Uploading...");
                            }
                        },
                    })
                    .then((response) => {
                        const result = response?.data?.statuscode;
                        setEmpData(response?.data?.data?.[0]?.payroll_details);
                        setStageData(response?.data?.data)
                        setId(response?.data?.data?.[0]?.stage_payroll_pk);
                        setResWarData({
                            warning: Object.keys(response?.data?.warningData || {}).length > 0 ? response?.data?.warningData : "",
                            stage_payroll_pk: response?.data?.data?.[0]?.stage_payroll_pk,
                            isOpen: Object.keys(response?.data?.warningData || {}).length > 0
                        })
                        setSelectTemp(response?.data?.data?.[0]?.template_name)
                        if (result) {
                            toast.dismiss();
                            toast.success("File uploaded successfully!");
                        }
                    });

                setUploadProgress(100);
                setFile(null);
            } catch (error) {
                setUploadProgress(0);
                toast.dismiss();
                toast.warning(error.response?.data?.message || error.message);
            }
        } catch (error) {
            console.error("Unexpected error", error);
        }
    }
    async function handleSubmit(e) {
        if (selecttemp === "Meepl Salary Template") {
            await handleCalculate("basic");
        } else if (selecttemp === "Advanced Meepl Salary Template : Annual") {
            await handleCalculate("advance");
        } else if (selecttemp === "Contractual Template") {
            await handleCalculate("contractual");
        } else if (selecttemp === "Contractual Template : Daily Fixed") {
            await handleCalculate("contractual-daily");
        } else if (selecttemp === "Contractual Template : Payable Days") {
            await handleCalculate("contractual-payable-days");
        } else if (selecttemp === "Advanced Meepl Salary Template : Monthly") {
            await handleCalculate("monthly-ctc");
        } else {
            toast.info("Invalid Template Type");
        }
        // else { 
        //     dispatch(BulkPayrollLoadAction(true));
        //     AddPayrollStagetoMainHelper().then((res) => {
        //         if (res?.data?.statuscode === 200) {
        //             toast.dismiss();
        //             toast.success("Payroll bulk upload completed successfully.");
        //             setEmpData([]);
        //         } else {
        //             toast.dismiss();
        //             toast.error("The bulk upload failed. Please try again.");
        //         }
        //     }).finally(() => {
        //         dispatch(BulkPayrollLoadAction(false));
        //     });
        // }

    }

    const handleCalculate = async (template_type) => {
        try {
            dispatch(BulkPayrollLoadAction(true));
            let finalResponse = null;

            if (template_type === "advance") {
                finalResponse = await BulkUploadCalculateAdvanceHelper();
            } else if (template_type === "basic") {
                finalResponse = await BulkUploadCalculateHelper();
            } else if (template_type === "contractual") {
                finalResponse = await BulkUploadCUContractualHelper();
            } else if (template_type === "contractual-daily") {
                finalResponse = await BulkUploadCUContractualDailyHelper();
            } else if (template_type === "contractual-payable-days") {
                finalResponse = await BulkUploadCUContractualPayableDaysHelper();
            } else if (template_type === "monthly-ctc") {
                finalResponse = await BulkUploadCalculateMonthlyCtcHelper();
            }
            if (finalResponse?.data?.statuscode === 200) {
                const resp = finalResponse?.data?.data?.[0]
                const resMessage = resp?.fn_blueprint_calculate_upsert || resp?.fn_advanced_blueprint_calculate_upsert ||
                resp?.fn_contractual_meepl_salary_calculate_upsert || resp?.fn_contractual_daily_fixed_calculate_upsert || resp?.fn_autocalculated_monthly_ctc_blueprint_calculate_upsert 

                toast.dismiss();
                toast.success("File processed successfully!");
                if (resMessage?.split(" ")[0] > 0) {
                    toast.warn(`PayConfig bulk upload failed for ${resMessage?.split(" ")[0]} record(s): Previous Employee ID is missing.`);
                }
                setEmpData([]);
                setStageData([]);
                handleReset();
            } else {
                toast.dismiss();
                toast.error("The bulk upload failed. Please try again.");
            }
        } catch (error) {
            toast.error("Error" + error.message);
        } finally {
            dispatch(BulkPayrollLoadAction(false));
        }
    };
    const handleCancel = () => {
        setSelectFileBtnLoading(true);
        DeletePayrollStageHelper({ stage_payroll_id: stageData?.length > 0 ? null : id }).then((res) => {
            if (res.data.statuscode === 200) {
                setEmpData([]); // Clear table data
                setFile(null); // Allow new file selection
                handleReset();
                setIsAdvancedTemplate(false);
                setContractual(false);
                setContractualDaily(false);
                setContractualPayableDays(false);
                setMonthlyCtcTemplate(false);
                setStageData([]);     
                document.getElementById("contained-button-file").click();
            } else {
                toast.error("Something went wrong")
            }
            setSelectFileBtnLoading(false);
            setShowConfirmPopup(false);
        });
    };
    const formatDecimal = (value) => {
        if (value === null || value === undefined) return "";
        const num = parseFloat(value);
        if (isNaN(num)) return "";
        return (Math.floor(num * 100) / 100).toFixed(2);
    };
    const handleEdit = (rowData) => {
        const formattedData = {};
        Object.keys(rowData).forEach((key) => {
            if (["previous_employee_id", "first_name", "last_name", "office_email"].includes(key)) {
                formattedData[key] = rowData[key];
            } else if (["conveyance_allowance", "educational_allowance", "medical_allowance", "lta"].includes(key)) {
                formattedData[key] = formatDecimal(rowData[key]);;
            } else if (["esic", "pt", "overtime_applicable_flag",
                "pf_earnings_applicable",
                "pf_limit_applicable",
                "transport_allowance_applicable",
                "transport_earning_applicable",
                "transport_deduction_applicable",
                "food_allowance_applicable",
                "food_earning_applicable",
                "food_deduction_applicable",
                "ph_wages_applicable",
                "leave_wages_applicable",
                "week_off_caln_applicable",
                "onhold_payroll_flag",
            ].includes(key)) {
                formattedData[key] = Boolean(rowData[key]); 
            }
            else {
                formattedData[key] = rowData[key];
            }
        });
        formattedData.earning_component_json = Array.isArray(rowData.earning_component_json)
            ? rowData.earning_component_json?.map((earning) => ({
                name: earning.name,
                label: earning.label,
                value: formatDecimal(earning.value),
            }))
            : [];
        formattedData.deduction_component_json = Array.isArray(rowData.deduction_component_json)
            ? rowData.deduction_component_json?.map((deduction) => ({
                name: deduction.name,
                label: deduction.label,
                value: formatDecimal(deduction.value),
            }))
            : [];
        formattedData["overtime_applicable_flag"] = Boolean(rowData["overtime_applicable_flag"]);
        formattedData["overtime_code"] = rowData["overtime_code"];
        
        setEditedRecord(formattedData);
        setOpenPopup(true);
    };
    const handleConfirmDelete = (rowData) => {
        setOpenDialog(true);
        setCurrentData(rowData)
    };
    const handleDelete = () => {
        const updatedData = empdata?.filter(emp => emp?.previous_employee_id !== currentData?.previous_employee_id); // Use unique field
        setEmpData(updatedData); // Update state
        toast.dismiss();
        toast.success("Record deleted successfully!");
        setOpenDialog(false);
        UpdatePayrollStageHelper({ stage_payroll_id: id, payroll_details: JSON.stringify(updatedData) }).then((res) => {
        });
    };

    // Edit functions 

    // const validateFields = () => {
    //     const tempErrors = {};
    //     if (!editedRecord?.previous_employee_id) tempErrors.previous_employee_id = "Prev.Emp ID is required.";
    //     if (!editedRecord?.ctc) tempErrors.ctc = "CTC is required.";
    //     if (!editedRecord?.basic) tempErrors.basic = "Basic is required.";
    //     if (!editedRecord?.hra) tempErrors.hra = "HRA is required.";
    //     setEditErrors(tempErrors);
    //     return Object.keys(tempErrors).length === 0; // Return true if no errors
    // };
    // const handleEditSubmit = (updatedRecord) => {
    //     if (!validateFields()) return;
    //     updatedRecord.earning_component_json = Array.isArray(updatedRecord.earning_component_json)
    //         ? updatedRecord.earning_component_json
    //         : [];
    //     updatedRecord.deduction_component_json = Array.isArray(updatedRecord.deduction_component_json)
    //         ? updatedRecord.deduction_component_json
    //         : [];
    //     updatedRecord.esic = Boolean(updatedRecord.esic);
    //     updatedRecord.pt = Boolean(updatedRecord.pt);
    //     updatedRecord.pf = Boolean(updatedRecord.pf);
    //     updatedRecord.overtime_applicable_flag = Boolean(updatedRecord.overtime_applicable_flag);
    //     const updatedData = empdata?.map((emp) =>
    //         emp.previous_employee_id === updatedRecord.previous_employee_id ? updatedRecord : emp
    //     );
    //     setEmpData(updatedData);
    //     UpdatePayrollStageHelper({
    //         stage_payroll_id: id,
    //         payroll_details: JSON.stringify(updatedData),
    //     }).then((res) => { });
    //     setOpenPopup(false);
    //     toast.dismiss();
    //     toast.success("Record updated successfully!");
    // };
    const handleEarnings = (templateType) => {
        const type = templateType || selecttemp; 
        let notAllowedEarnings = [];

        if (type === "Advanced Meepl Salary Template : Annual") {
            notAllowedEarnings = [
                "basic",
                "house_rent_allowance",
                "conveyance_allowance",
                "medical_allowance",
                "education_allowance",
                "leave_travel_allowance",
                "employees_state_insurance_corporation",
                "employer_contribution_to_pf",
                "gratuity",
                "statutory_bonus",
                "overtime_pay",
                "special_allowance", // it is an adjustment component
                "variable_pay"
            ];
        } else if (
            type === "Contractual Template" || 
            type === "Contractual Template : Payable Days" ||
            type === "Contractual Template : Daily Fixed"
        ) {
            notAllowedEarnings = [
                "conveyance_allowance",
                "medical_allowance",
                "education_allowance",
                "leave_travel_allowance",
                "employees_state_insurance_corporation",
                "gratuity",
                "statutory_bonus",
                "employer_contribution_to_pf",
                "leave_wages",
                "ph_allowance",
                "overtime_pay",
            ];
        } else if (type === "Advanced Meepl Salary Template : Monthly") {
            notAllowedEarnings = [
                "employees_state_insurance_corporation",
                "employer_contribution_to_pf",
                "gratuity",
                "statutory_bonus",
                "overtime_pay",
            ];
        } 

        let filteredEarnings = [];
        if (custom_earning_data) {
            const earnings = custom_earning_data?.[0]?.earnings_json || [];
            filteredEarnings = notAllowedEarnings.length
                ? earnings.filter(earning => !notAllowedEarnings.includes(earning?.name))
                : earnings;
            setEarningData({ load: false, values: filteredEarnings });
        }
        return filteredEarnings;
    };

    useEffect(()=> {
        handleEarnings();
        if (selecttemp === "Meepl Salary Template") {
                setExcelDbColMapping(initialColMapping)
        } else if (selecttemp === "Advanced Meepl Salary Template : Annual") {
            let newField = { excel: "", db: "variable_percentage", label: "Variable Pay %", required: false }
            let newInitialCol = [...initialColMapping]
                newInitialCol.splice(4, 0, newField);
            setExcelDbColMapping(newInitialCol);
        } else if (selecttemp === "Contractual Template" || 
            selecttemp === "Contractual Template : Daily Fixed" || 
            selecttemp === "Contractual Template : Payable Days"
        ) {
            let newField = [
                { excel: "", db: "leave_wages_applicable", label: "Leave Wages", required: false },
                { excel: "", db: "ph_wages_applicable", label: "Public Holiday Wages", required: false }
            ]
            let newInitialCol = initialColMapping?.filter(item => item.db !== "gratuity_flag"); // remove gratuity field
            newInitialCol.splice(1, 3); // remove first 3 elements
            newInitialCol.push(...newField); // add new fields at the end
            setExcelDbColMapping(newInitialCol);
        } else if (selecttemp === "Advanced Meepl Salary Template : Monthly") {
            let newInitialCol = [
                initialColMapping[0],
                ...initialColMapping.slice(8, 11),
                ...initialColMapping.slice(11)
            ]
            setExcelDbColMapping(newInitialCol);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selecttemp,contractual, contractualDaily, monthlyCtcTemplate])
    const handleAddEarningFields = () => {
        setTemplateEarningData((state) => [...state, templateEarningsValues]);
        setExcelDbCol([...excelDbCol, { db: "", excel: "" }]);
    };
    const handleEarningChange = (e, value, id) => {
        let newArr = [...templateEarningData];
        let item = newArr[id];
        item = { ...item, [e]: value };
        newArr[id] = item;
        setTemplateEarningData(newArr);

    }
    const handleEarningColumnChange = (index, value) => {
        const newExcelDbCol = [...excelDbCol];
        newExcelDbCol[index] = { ...newExcelDbCol[index], excel: value };
        setExcelDbCol(newExcelDbCol);
    };

    const handleEarningDelete = (deleteId) => {
        setTemplateEarningData((prevData) => prevData?.filter((_, index) => index !== deleteId));
        setExcelDbCol((prevMappings) => prevMappings?.filter((_, index) => index !== deleteId));
    };
    const getFilteredEarnings = (id) => {
        const selectedEarnings = templateEarningData?.map((item, index) => index !== id && item.earning_key?.name)?.filter(Boolean);
        
        const hasFixedDA = selectedEarnings?.includes("fixed_dearness_allowance");
        const hasVariableDA = selectedEarnings?.includes("variable_dearness_allowance");

        return earningData?.values?.filter((option) => {
            // Filter out already selected earnings
            if (selectedEarnings?.includes(option.name)) return false;

            // DA: if one is selected, hide the other
            if (hasFixedDA && option?.name === "variable_dearness_allowance") return false;
            if (hasVariableDA && option?.name === "fixed_dearness_allowance") return false;

            return true;
        });
    };


    const handleAddDeductionFields = () => {
        setTemplateDeductionData((state) => [...state, templateDeductionsValues]);
        setExcelDbCol1([...excelDbCol1, { db: "", excel: "" }]);
    };
    const handleDeductionDelete = (deleteId) => {
        setTemplateDeductionData((prevData) => prevData?.filter((_, index) => index !== deleteId));
        setExcelDbCol1((prevMappings) => prevMappings?.filter((_, index) => index !== deleteId));
    };
    const handleDeductions = () => {
        const notAllowedDeductions = [
            "professional_tax",
            "standard_deduction",
            "employee_contribution_to_pf",
            "employees_state_insurance_corporation",
            "income_tax"
        ];
        if (custom_deduction_data) {
            const filteredDeductions = custom_deduction_data?.[0]?.deductions_json?.filter(deduction =>
                !notAllowedDeductions.includes(deduction.name)
            );
            setDeductionData({ load: false, values: filteredDeductions });
            return filteredDeductions;
        }
        return [];
    };
    const getFilteredDeductions = (id) => {
        const selectedDeduction = templateDeductionData?.map((item, index) => index !== id && item.deduction_key?.name)?.filter(Boolean);
        return deductionData.values?.filter(
            (option) => !selectedDeduction?.includes(option.name)
        );
    };
    const handleDeductionChange = (e, value, id) => {
        let newArr = [...templateDeductionData];
        let item = newArr[id];
        item = { ...item, [e]: value };
        newArr[id] = item;
        setTemplateDeductionData(newArr);
    }
    const handleDeductionColumnChange = (index, value) => {
        const newExcelDbCol = [...excelDbCol1];
        newExcelDbCol[index] = { ...newExcelDbCol[index], excel: value };
        setExcelDbCol1(newExcelDbCol);
    };

    const meeplSalaryTemplate = [
        ["Prev.Emp ID", "CTC (Annual)", "Basic (% of CTC)", "HRA (% of Basic Pay)", "Conveyance Allowance (Fixed)", "Medical Allowance (Fixed)", "Educational Allowance (Fixed)", "LTA (Fixed)", "ESI Number", "ESIC Applicable (Yes/No)", "PT Applicable (Yes/No)", "Statutory Bonus(Yes/No)", "Gratuity(Yes/No)", "PF Compliant Tag(Yes/No)", "EPF Number", "PF Applicable (Yes/No)", "EPS Applicable (Yes/No)", "PF Limit Amount (Amount/No)", "Overtime (Code/No)", "Transport Allowance (Earning/Deduction/No)", "Food Allowance (Earning/Deduction/No)", "Include Paid Week Offs", "Monthly Working Hours Calculation", "Hold Salary"],
        ["EMP001", "100000", "50", "50", "1250", "1600", "200", "100", "12345678901234567", "Yes", "Yes", "No", "No", "Yes", "AB/XYZ/1234567/001/1234567", "No", "No", "No", "No", "No", "No","Yes", "No", "No"],
    ];

    const advancedMeeplSalaryTemplate = [
        ["Prev.Emp ID", "CTC (Annual)", "Basic (% of CTC)", "HRA (% of Basic Pay)", "Variable (% of CTC)", "Conveyance Allowance (Fixed)", "Medical Allowance (Fixed)", "Educational Allowance (Fixed)", "LTA (Fixed)", "ESI Number", "ESIC Applicable (Yes/No)", "PT Applicable (Yes/No)", "Statutory Bonus(Yes/No)", "Gratuity(Yes/No)", "PF Compliant Tag(Yes/No)", "EPF Number","PF Applicable (Yes/No)", "EPS Applicable (Yes/No)", "PF Limit Amount (Amount/No)", "Overtime (Code/No)", "Transport Allowance (Earning/Deduction/No)", "Food Allowance (Earning/Deduction/No)", "Include Paid Week Offs", "Monthly Working Hours Calculation", "Hold Salary"],
        ["EMP001", "100000", "50", "50", "10", "1250", "1600", "200", "100","12345678901234567", "Yes", "Yes", "No", "No", "Yes", "AB/XYZ/1234567/001/1234567", "No", "No","No", "No", "No", "No", "Yes", "No", "No"],
    ];
    const contractualTemplate = [
        ["Prev.Emp ID", "Basic", "Conveyance Allowance (Fixed)", "Medical Allowance (Fixed)", "Educational Allowance (Fixed)", "LTA (Fixed)", "ESI Number", "ESIC Applicable (Yes/No)", "PT Applicable (Yes/No)", "Statutory Bonus(Yes/No)", "PF Compliant Tag(Yes/No)", "EPF Number","PF Applicable (Yes/No)", "EPS Applicable (Yes/No)", "PF Limit Amount (Amount/No)", "Overtime (Code/No)", "Leave Wages(Yes/No)", "Public Holiday Wages(Yes/No)", "Transport Allowance (Earning/Deduction/No)", "Food Allowance (Earning/Deduction/No)", "Include Paid Week Offs", "Monthly Working Hours Calculation", "Hold Salary"],
        ["EMP001", "0", "1250", "1600", "200", "100","12345678901234567", "Yes", "Yes", "No", "Yes", "AB/XYZ/1234567/001/1234567", "No", "No", "No", "No", "No", "No", "No", "No", "Yes", "No","No"],
    ];

    const meeplCtcMonthlyTemplate = [
        ["Prev.Emp ID", "Basic", "ESI Number", "ESIC Applicable (Yes/No)", "PT Applicable (Yes/No)", "Statutory Bonus(Yes/No)", "Gratuity(Yes/No)", "PF Compliant Tag(Yes/No)", "EPF Number", "PF Applicable (Yes/No)", "EPS Applicable (Yes/No)", "PF Limit Amount (Amount/No)", "Overtime (Code/No)", "Transport Allowance (Earning/Deduction/No)", "Food Allowance (Earning/Deduction/No)", "Include Paid Week Offs", "Monthly Working Hours Calculation", "Hold Salary"],
        ["EMP001", "0", "12345678901234567", "Yes", "Yes", "No", "No", "Yes", "AB/XYZ/1234567/001/1234567", "No", "No", "No", "No", "No", "No", "Yes", "No", "No"],
    ];

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleDownload = (type) => {
        let data, fileName;
        setSelectTemp(type)
        if (type === "Meepl Salary Template") {
            data = meeplSalaryTemplate;
            fileName = "Meepl_Salary_Template.xlsx";
        } else if (type === "Advanced Meepl Salary Template : Annual") {
            data = advancedMeeplSalaryTemplate;
            fileName = "Advanced_Meepl_Salary_Template: Annual.xlsx";
        } else if (type === "Contractual Template") {
            data = contractualTemplate;
            fileName = "Contractual_Template.xlsx";
        } else if (type === "Contractual Template : Daily Fixed") {
            data = contractualTemplate;
            fileName = "Contractual_Template_Daily_Fixed.xlsx";
        } else if (type === "Contractual Template : Payable Days") {
            data = contractualTemplate;
            fileName = "Contractual_Template_Payable_Days.xlsx";
        } else if (type === "Advanced Meepl Salary Template : Monthly"){
            data = meeplCtcMonthlyTemplate;
            fileName = "Advanced Meepl Salary Template: Monthly.xlsx";
        }
        const templateBasedEarnings = handleEarnings(type)
        const deductionDatas = handleDeductions();
        const ws = XLSX.utils.aoa_to_sheet(data);
        const overtimeCodes = ot_data?.map((el) => el.alias_name).join(", ") || "N/A";
        const allEarData = templateBasedEarnings?.map((el) => el.label).join(", ") || "N/A"
        const allDedData = deductionDatas?.map((el) => el.label).join(", ") || "N/A"
        const guideData = [
            ["Payroll Configuration Guide (Input Format)"],
            [""],
            ["Prev.Emp ID:", "Reference ID / Employee ID from the legacy system / Org ID / Biometric ID as applicable."],
            ["Overtime Code:", `${overtimeCodes}`],
            
        ];
        if (type !== "Meepl Salary Template") {
            guideData.push(["Earning Components:", `${allEarData}`])
            guideData.push(["Deduction Components:", `${allDedData}`]);
        }
        guideData.push([""]);
        if (["Advanced Meepl Salary Template : Annual", "Meepl Salary Template"].includes(type)) {
            guideData.push(["Basic (%):","As per wage compliance, Basic must be at least 50% of CTC."]);
        }
        guideData.push(["PF Applicable; PF Compliant Tag:", "When PF is enabled, the PF Compliant Tag is automatically applied as per statutory rules."])
        guideData.push([""]);
        const ws2 = XLSX.utils.aoa_to_sheet(guideData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Template");
        XLSX.utils.book_append_sheet(wb, ws2, "Template Filling Guide");
        XLSX.writeFile(wb, fileName);

        handleCloseMenu();
    };


const handleExportWarningListExcel = () => {
    const data = Object.values(resWarData?.warning || [])?.map(item => {
        const row = {
            "Prev.Emp ID": item.previous_employee_id || "-"
        };
        item?.reasons?.forEach((reason, index) => {
            row[`Reason ${index + 1}`] = reason;
        });
        return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Warnings");
    XLSX.writeFile(workbook, "Payroll_Bulk_Upload_Warnings.xlsx");
};
    return (
        <>
            {
                (isLoading) &&
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    backgroundColor: '#f0f4f8'
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginBottom: '10px'
                    }}>
                        <Typography sx={{ mb: 2 }} variant='h4'>Your file is being processed. We shall notify you once process is completed.</Typography>

                    </div>
                </div>
            }
            <Box sx={{ maxHeight: "calc(100vh - 125px)", overflowY: "auto" }}>
                <Box>
                    <form
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "16px",
                        }}
                    >
                        <Box sx={{display: "flex", gap: "10px", alignItems: "center", flex: 1}}>
                        
                        <div style={{  display: "flex", alignItems: "center", gap: "10px" }}>
                            <p
                                style={{
                                    color: "blue",
                                    padding: "5px",
                                    borderRadius: "8px",
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #dce3ea",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease-in-out",
                                    "&:hover": {
                                        backgroundColor: "#e8f5e9",
                                    },
                                }}
                                onClick={handleOpenMenu}
                            >
                                📄 Download Sample Excel Template
                            </p>
                            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
                                <MenuItem onClick={() => handleDownload("Meepl Salary Template")}>Meepl Salary Template</MenuItem>
                                <MenuItem onClick={() => handleDownload("Advanced Meepl Salary Template : Monthly")}>Advanced Meepl Salary Template : Monthly</MenuItem>
                                <MenuItem onClick={() => handleDownload("Advanced Meepl Salary Template : Annual")}>Advanced Meepl Salary Template : Annual</MenuItem>
                                <MenuItem onClick={() => handleDownload("Contractual Template")}>Contractual Template</MenuItem>
                                <MenuItem onClick={() => handleDownload("Contractual Template : Daily Fixed")}>Contractual Template : Daily Fixed</MenuItem>
                                <MenuItem onClick={() => handleDownload("Contractual Template : Payable Days")}>Contractual Template : Payable Days</MenuItem>
                            </Menu>
                        </div>
                        </Box>
                        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                {file ? (
                                    <p style={{ margin: 0 }}>{file.name.substring(0, 20)}...</p>
                                ) : errors?.selectedFile ? (
                                    <p style={{ color: "red", margin: 0 }}>No file chosen</p>
                                ) : (
                                    <p style={{ margin: 0 }}>No file chosen</p>
                                )}
                            </div>
                            <label htmlFor="contained-button-file" style={{ display: "none" }}>
                                <input
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    id="contained-button-file"
                                    type="file"
                                    style={{ display: "none" }}
                                    multiple={false}
                                    onChange={fileSelected}
                                />
                            </label>
                            <Button
                                variant="contained"
                                className="mpl-primary-btn"
                                component="span"
                                sx={{ marginBottom: "5px" }}
                                disabled={selectFileBtnLoading}
                                onClick={handleSelectFileClick}
                            >
                                {selectFileBtnLoading ? <CircularProgress disableShrink size={24}/> : "Select File"} 
                            </Button>
                            <Button
                                variant="contained"
                                className="mpl-primary-btn"
                                sx={{ marginBottom: "5px", marginRight: "5px" }}
                                disabled={empdata?.length === 0 || empdata === undefined || isLoading}
                                onClick={handleSubmit}
                                startIcon={isLoading ? <CircularProgress size={18} color="inherit" /> : null}
                            >
                                Submit
                            </Button>
                        </div>
                    </form>
                </Box>
                <MaterialTable
                    isLoading={selectFileBtnLoading}
                    columns={[ 
                        {
                            title: "Prev.Emp ID",
                            cellStyle: { padding: "10px 10px 10px 13px" },
                            field: "previous_employee_id",
                            grouping: false,
                        },
                        {
                            title: "CTC (Annually)",
                            cellStyle: { padding: "10px 10px 10px 13px" },
                            render: rowData => rowData.ctc ? parseFloat(rowData?.ctc).toFixed(2) : "",
                            hidden: selecttemp !== "Advanced Meepl Salary Template : Annual" && selecttemp !== "Meepl Salary Template"
                        },
                        {
                            title: "Basic",
                            cellStyle: { padding: "10px 10px 10px 13px" },
                            render: rowData => rowData.basic ? parseFloat(rowData?.basic).toFixed(2) : "",
                            hidden: selecttemp !== "Advanced Meepl Salary Template : Annual" && selecttemp !== "Meepl Salary Template"
                        },
                        {
                            title: "Earnings",
                            cellStyle: { padding: "10px 10px 10px 13px" },
                            render: rowData => rowData?.earning_component_json?.length > 0 ? rowData?.earning_component_json
                            ?.map(el => `${el.label}: ${el.value}`)
                            .join(', ') : "",
                            hidden: selecttemp === "Advanced Meepl Salary Template : Annual" || selecttemp === "Meepl Salary Template" 
                        },
                    ]}
                    data={empdata}
                    options={{
                        maxBodyHeight: "calc(100vh - 290px)",
                        minBodyHeight: "calc(100vh - 290px)",
                        rowStyle: { fontSize: "13px" },
                        headerStyle: { padding: "10px 10px 10px 13px", fontWeight: "bold" },
                        sorting: true,
                        search: true,
                        searchText: "",
                        searchFieldAlignment: "right",
                        searchAutoFocus: true,
                        searchFieldVariant: "standard",
                        filtering: false,
                        paging: true,
                        pageSizeOptions: [25, 50],
                        pageSize: 25,
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        paginationPosition: "bottom",
                        exportButton: false,
                        exportAllData: false,
                        exportFileName: "Employees",
                        addRowPosition: "first",
                        selection: false,
                        actionsColumnIndex: -1,
                        showSelectAllCheckbox: true,
                        showTextRowsSelected: true,
                        grouping: false,
                        columnsButton: false,
                    }}
                    actions={[
                        {
                            icon: () => <IconButton sx={{ padding: "0px" }}><PreviewIcon /></IconButton>,
                            tooltip: "Stage Preview",
                            onClick: (_event, rowData) => { handleEdit(rowData) },
                        },
                        {
                            icon: () => <IconButton sx={{ padding: "0px" }}><DeleteIcon /></IconButton>,
                            tooltip: "Delete",
                            onClick: (_event, rowData) => { handleConfirmDelete(rowData) },
                        },
                    ]}
                    title="PayConfig Bulk Upload"
                />
                <Popup
                    maxWidth="sm"
                    fullWidth={true}
                    title="Pls map the column headers from your sheet & Meepl Fields"
                    openPopup={file}
                    close={false}
                    setOpenPopup={setOpenBulk}
                >
                    <Box>
                        <Box sx={{ m: 1 }}>
                            <FormControl fullWidth>
                                <SelectableSearch
                                    isOptionEqualToValue={(option, value) =>
                                        +option.template_id === +value.template_id
                                    }
                                    label="Select from Saved Templates"
                                    fullWidth
                                    value={inputData?.template_id}
                                    loading={() => handleTemplate()}
                                    fieldLabel="template_name"
                                    required={false}
                                    variantType={"standard"}
                                    name="template_id"
                                    size="small"
                                    onChangeEvent={handleInput}
                                    data={templateData}
                                />
                            </FormControl>
                        </Box>
                        <Box
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                alignItems: "center",
                                padding: 5,
                                borderBottom: "1px solid gray",
                            }}
                        >
                            <Typography variant="h6" style={{ textAlign: "center" }}>
                                Imported Headers
                            </Typography>
                            <Typography variant="h6" style={{ textAlign: "center" }}>
                                Meepl Fields
                            </Typography>
                        </Box>
                        {earningTempSelected && (
                            <>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
                                    <Typography variant="h6">Earnings Components</Typography>
                                    <Tooltip title="Add Earning">
                                        <IconButton className="mpl-primary-btn" onClick={handleAddEarningFields}>
                                            <AddIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>

                                {templateEarningData?.map((earning, index) => (
                                    <Grid container spacing={1} key={index} alignItems="center" sx={{ mt: 1 }}>
                                        <Grid item xs={6}>
                                            <FormControl fullWidth variant="standard">
                                                <Select
                                                    value={excelDbCol[index]?.excel || ""}
                                                    onChange={(e) => handleEarningColumnChange(index, e.target.value)}
                                                    fullWidth
                                                >
                                                    {rowHeaders?.map((header) => (
                                                        <MenuItem key={header} value={header}>
                                                            {header}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <FormControl fullWidth>
                                                <SelectableSearch
                                                    isOptionEqualToValue={(option, value) => option.label === value.label}
                                                    value={earning?.earning_key}
                                                    loading={() => handleEarnings()}
                                                    fieldLabel="label"
                                                    required={false}
                                                    variantType="standard"
                                                    name="earning_key"
                                                    size="small"
                                                    onChangeEvent={(e, newValue) => handleEarningChange("earning_key", newValue, index)}
                                                    data={{ load: earningData.load, values: getFilteredEarnings(index) }}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <IconButton color="error" onClick={() => handleEarningDelete(index)}>
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
                                    <Typography variant="h6">Deductions Components</Typography>
                                    <Tooltip title="Add Deduction">
                                        <IconButton className="mpl-primary-btn" onClick={handleAddDeductionFields}>
                                            <AddIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>

                                {templateDeductionData?.map((deduction, index) => (
                                    <Grid container spacing={1} key={index} alignItems="center" sx={{ mt: 1 }}>
                                        <Grid item xs={6}>
                                            <FormControl fullWidth variant="standard">
                                                <Select
                                                    value={excelDbCol1[index]?.excel || ""}
                                                    onChange={(e) => handleDeductionColumnChange(index, e.target.value)}
                                                    fullWidth
                                                >
                                                    {rowHeaders?.map((header) => (
                                                        <MenuItem key={header} value={header}>
                                                            {header}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <FormControl fullWidth>
                                                <SelectableSearch
                                                    isOptionEqualToValue={(option, value) => option.label === value.label}
                                                    value={deduction?.deduction_key}
                                                    loading={() => handleDeductions()}
                                                    fieldLabel="label"
                                                    required={false}
                                                    variantType="standard"
                                                    name="deduction_key"
                                                    size="small"
                                                    onChangeEvent={(e, newValue) => handleDeductionChange("deduction_key", newValue, index)}
                                                    data={{ load: deductionData.load, values: getFilteredDeductions(index) }}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <IconButton color="error" onClick={() => handleDeductionDelete(index)}>
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                ))}
                            </>
                        )}
                        {excelDbColMapping?.map((col) => (
                            <Grid
                                key={col.db}
                                container
                                spacing={2}
                                style={{
                                    padding: 5,
                                    alignItems: "center",
                                }}
                            >
                                <Grid sx={{ mt: 2 }} item xs={7} container alignItems="center" spacing={1}>
                                    <Grid item xs={10}>
                                        <Select
                                            onChange={(e) => setColMapping(e.target.value, col.db)}
                                            value={col.excel}
                                            fullWidth
                                            required={col.required}
                                            variant="standard"
                                        >
                                            {rowHeaders?.map((header) => (
                                                <MenuItem key={header} value={header}>
                                                    {header}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    {col.excel && (
                                        <Grid item xs={2}>
                                            <IconButton onClick={() => clearColMapping(col.db)}>
                                                <CloseIcon />
                                            </IconButton>
                                        </Grid>
                                    )}
                                </Grid>
                                <Grid sx={{ mt: 2 }} item xs={5}>
                                    <Typography>
                                        {col.label || col.db}
                                        {col.required && " *"}
                                       { col.db === "previous_employee_id" && <Tooltip title={"Reference ID / Employee ID from the legacy system / Org ID / Biometric ID as applicable."} arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer", marginLeft: "5px" }} />
                                        </Tooltip> }

                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", m: 2 }}>
                        <Button
                            onClick={() => {
                                setFile(null);
                                setRowHeaders([]);
                                setOpenBulk(false);
                            }}
                            className="mpl-primary-btn"
                            disabled={uploadProgress > 0 && uploadProgress < 100}
                        >
                            Close
                        </Button>
                        <Button
                            variant="contained"
                            type="submit"
                            className="mpl-primary-btn"
                            disabled={uploadProgress > 0 && uploadProgress < 100}
                            onClick={addPayrollStage}
                            startIcon={(uploadProgress > 0 && uploadProgress < 100) ? <CircularProgress size={18} color="inherit" /> : null}
                        >
                            Upload
                        </Button>
                    </Box>
                </Popup>
                <Popup
                    maxWidth="xs"
                    fullWidth={true}
                    title="Attention Needed!"
                    openPopup={showConfirmPopup}
                    close={false}
                    setOpenPopup={setShowConfirmPopup}
                >
                    <Typography variant="h5"> You will lose the imported data. Do you want to submit it before proceeding? </Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                        <Button
                            onClick={handleCancel}
                            className="mpl-primary-btn"
                            disabled={selectFileBtnLoading}
                            startIcon={selectFileBtnLoading ? <CircularProgress size={18} color="inherit" /> : null}
                    
                        >
                            No
                        </Button>

                        <Button
                            onClick={() => {
                                setShowConfirmPopup(false); // Close popup and retain existing data
                            }}
                            className="mpl-primary-btn"
                        >
                            Yes
                        </Button>

                    </Box>
                </Popup>
                <Popup
                    title={"Preview Employee"}
                    openPopup={openPopup}
                    setOpenPopup={setOpenPopup}
                >
                    <PayrollBulkPreview
                        excelDbColMapping = {excelDbColMapping} 
                        editedRecord={editedRecord} 
                        setEditedRecord={setEditedRecord}
                        earningTempSelected={earningTempSelected}
                        selecttemp={selecttemp}
                    />
                </Popup>
                <ConfirmationDialog
                    title="Do you wish to proceed?"
                    openDialog={openDialog}
                    closeDialog={setOpenDialog}
                    OkButtonText="Delete"
                    onSubmit={handleDelete}
                />
                {/* // Warning Popup */}
                <Popup
                    title={
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <WarningAmberIcon color="warning" fontSize="small" />
                                Warning
                            </Box>
                            <Tooltip title="Export as Excel" arrow>
                                <IconButton size="small" onClick={handleExportWarningListExcel}>
                                    <CloudDownloadIcon sx={{ color: "inherit" }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    }
                    openPopup={(resWarData?.isOpen && id === resWarData?.stage_payroll_pk) || false}
                    setOpenPopup={() => setResWarData({})}
                >
                    <TableContainer component={Paper}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell width={120}><b>Prev.Emp ID</b></TableCell>
                                    <TableCell><b>Reason</b></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {Object.values(resWarData?.warning || [])?.map((item, idx) => (
                                    <TableRow key={idx} sx={{ "& td": { py: 1 }, "&:not(:last-child)": { borderBottom: "2px solid #fff" } }}>
                                        <TableCell>{item?.previous_employee_id || "-"}</TableCell>
                                        <TableCell>
                                            {Array.isArray(item?.reasons) && item.reasons.length > 0 ? (
                                                item.reasons.map((r, i) => (
                                                <div key={i}>• {r}</div>
                                                ))
                                            ) : (
                                                "-"
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Popup>
            </Box>
        </>
    );
};

export default PayrollBulkUpload;